<script setup>
import { onMounted, ref } from "vue";

import { store } from "@/store";
import AppAlert from "@/components/AppAlert";
import AppAlertCard from "@/components/AppAlertCard";
import AppButton from "@/components/AppButton";
import AppFormInput from "@/components/Form/AppFormInput";
import AppCard from "@/components/AppCard";
import AppGuestShell from "@/components/AppGuestShell";
import AppGuestHeader from "@/components/AppGuestHeader";

// Api
import useApi from "@/composables/useApi";
const { user } = useApi();

const contract = ref(null);
const formSent = ref(false);
const loading = ref(false);
const hasError = ref(false);

const connectionPublicUser = async () => {
  try {
    const data = await user.publicUser();
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

async function submitForm() {
  try {
    if (!contract.value || loading.value) {
      return;
    }

    hasError.value = false;
    loading.value = true;
    console.log("contract.value: ", contract.value);
    await connectionPublicUser();

    const data = await user.newUserPortal(contract.value);
    console.log(data);

    formSent.value = true;
  } catch (error) {
    hasError.value = true;
    // TODO: mostrar una alerta de error
  } finally {
    loading.value = false;
  }
}

onMounted(async () => {
  try {
    store.APP_LOADING = true;
  } finally {
    store.APP_LOADING = false;
  }
});
</script>

<template lang="pug">
AppGuestShell
  AppCard(padding="lg" elevated v-if="!formSent")
    AppGuestHeader(
      icon="uil uil-user-plus"
      :title="$t('register.title')"
      :subtitle="$t('register.subtitle')"
    )
    transition(name="alert")
      AppAlert.new-user__alert(
        :title="$t('register.error_title')"
        :subtitle="$t('register.error_subtitle')"
        v-if="hasError"
      )
    form(@submit.prevent="submitForm")
      AppFormInput(
        type="text"
        name="service_number"
        icon="uil uil-file-alt"
        :label="$t('quickpayment.service_number')"
        :disabled="loading"
        @update:value="contract = $event"
        required
      )
      AppButton(:loading="loading" :disabled="loading" :label="$t('common.send')")
    .guest-divider
    router-link.guest-action(:to="{ name: 'Login' }")
      i.uil.uil-arrow-left(aria-hidden="true")
      span {{ $t("common.backToLogin") }}
  AppAlertCard(:title="$t('password_reset.valid_email')" :subtitle="$t('password_reset.check_mail')" v-else)
</template>

<style lang="scss" scoped>
.new-user {
  &__alert {
    @apply mb-5;
  }
}

.alert-enter-active,
.alert-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.alert-enter-from,
.alert-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>
